<template>

    <header id="site-header" ref="rootElement" class="sitewide-header w-full z-40 left-0 top-0 p-4" :class="rootClasses">

        <div class="grid relative z-10">

            <div class="logo-container">
                <Link class="logo" :href="context.site.url">
                    <Logo></Logo>
                </Link>
            </div>

            <nav class="main-menu relative unscrolled hidden ht:flex justify-end items-center">
                <div v-for="link in context.nav.main_menu" class="top-level-link ml-6 relative">
                    <Link class="text-white uppercase tracking-wide text-xs font-medium relative inline-block" :href="link.href">{{ link.name }}</Link>
                    <div class="children absolute left-0 bg-primary-600" v-if="link.children.length">
                        <div class="child-link" v-for="child in link.children">
                            <Link @click="linkOut" class="block p-2 bg-primary-600 transition-colors hover:bg-secondary-600 focus:bg-secondary-600 text-center" :href="child.href" v-html="child.name"></Link>
                        </div>
                    </div>
                </div>
            </nav>

            <div v-if="context.nav.header_buttons.length" class="header-buttons flex items-center">
                <div v-for="button in context.nav.header_buttons">
                    <Button :label="button.name" :url="button.href" variant="button-3"></Button>
                </div>
            </div>

            <div class="burger-container px-2 flex ht:hidden items-center justify-end vt:justify-center">
                <button @click="openMobileMenu" class="burger-button inline-block appearance-none text-white relative">
                    <i class="fas fa-bars relative z-10 text-3xl"></i>
                    <span class="sr-only">Open Mobile Menu</span>
                </button>
            </div>

        </div>

    </header>

</template>

<script>
import Logo from './Utilities/ActumLogo.vue';
import { ref, computed, onMounted, nextTick } from 'vue';
import { Inertia } from '@inertiajs/inertia';

const $ = window.jQuery;

export default {
    
    props: ['context', 'background'],

    setup(props) {

        const appState = ref('idle');
        const scrolled = ref(false);
        const rootElement = ref(null);
        const linkingOut = ref(false);

        function registerScrollListener() {
            let myHeight = rootElement.value.clientHeight;
            $(window).scroll(function() {
                let distance = $(window).scrollTop();
                if (distance >= myHeight) {
                    scrolled.value = true;
                } else {
                    scrolled.value = false;
                }
            });
        }

        onMounted(() => {
            Inertia.on('start', (e) => {
                scrolled.value = false;
            });
        });

        onMounted(registerScrollListener);

        const rootClasses = computed(() => {
            let output = scrolled.value
                ? 'scrolled'
                : 'unscrolled';
            output = output + ' ' + props.background + '-background';

            if (linkingOut.value) {
                output = output + ' linking-out';
            }

            return output;
        });

        const openMobileMenu = () => {
            let e = new CustomEvent("openMobileMenu", {
                detail: {}
            });
            window.dispatchEvent(e);
        };

        const linkOut = () => {
            linkingOut.value = true;
            console.log('lonk');
        }

        return {
            appState,
            linkOut,
            openMobileMenu,
            rootElement,
            rootClasses,
            scrolled
        };

    },

    components: {
        Logo
    }

}
</script>